angular.module('assets')
    .component('assetProjectListComponent', {
        bindings: {
            filters: '<',
            page: '<',
        },
        templateUrl: 'app/asset/_project-table.html',
        controller: function ($scope, $state, $stateParams, AssetService, Project) {
            this.AssetService = AssetService;

            this.$onInit = () => {
                Project.autocomplete().$promise.then(items => {
                    if(this.filters.project == null || this.filters.project.length === 0){
                        this.selectedProjects = items
                    }
                    else {
                        this.selectedProjects = items.filter(item => this.filters.project.includes(item.id))
                    }
                })
            }

            $scope.$on('asset.updated', () => $state.reload());
        }
    })
